import { useEffect, useRef } from "react";
import { useGlobalState } from "shared/contexts/Global";

import styles from "./GoogleMap.module.scss";
import useScript from "./useScript";

export const GoogleMap = ({ lat, lng }) => {
  const ref = useRef(null);

  const { googleMapsApiKey, googleMapsPinImage } = useGlobalState();

  const status = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}`
  );

  useEffect(() => {
    if (status === "ready" && ref.current) {
      const map = new window.google.maps.Map(ref.current, {
        center: { lat, lng },
        zoom: 13,
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        scaleControl: true,
        scrollwheel: false,
        panControl: true,
        streetViewControl: false,
        draggable: true,
        overviewMapControl: true,
        overviewMapControlOptions: {
          opened: false,
        },
        styles: [
          {
            stylers: [
              {
                saturation: -200,
              },
            ],
          },
        ],
      });

      new window.google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        icon: googleMapsPinImage.url,
      });
    }
  }, [googleMapsPinImage, lat, lng, status]);

  return <div className={styles.map} ref={ref} />;
};
